import { render, staticRenderFns } from "./Swarm.vue?vue&type=template&id=b8cb1d66&scoped=true"
import script from "./Swarm.vue?vue&type=script&lang=js"
export * from "./Swarm.vue?vue&type=script&lang=js"
import style0 from "./Swarm.vue?vue&type=style&index=0&id=b8cb1d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cb1d66",
  null
  
)

export default component.exports